

























































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Group, GroupStatus } from "@/store/eventqueue/types";
import moment from "moment";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		tree: () => import("./Tree.vue")
	}
})
export default class tree extends Vue {
	@Prop(Object) group: any;
	@Prop(String) title: string;
	@Prop(Array) subGroups: any[];
	@Prop(Boolean) open: boolean;
	@Prop(Object) node: any;
	@Prop(Boolean) isClickableChildNode: boolean;
	@Prop({type:Boolean, default: false}) showOnTestIcon: boolean;

	//Will map to a field in the group object, if the field is true, the option can be selected, if null normal logic applies
	@Prop({ type: String, default: "" }) enabledFlag : string; 

	@Prop({ default: () => { return [] } })
	public selectedGroupIDs: number[];

	@Prop({ default: true }) allowDoubleclick: boolean;

	@Prop({ type: Boolean, default: false }) showStatus: boolean;

	private get isGroupSelectable(): boolean{
		if (!this.enabledFlag || typeof this.group[this.enabledFlag] !== "boolean") return true;
		return this.group[this.enabledFlag];
	}
	
	private nodeStyle(status: GroupStatus): string {
		if (!this.showStatus || !status) {
			return "";
		}
		switch (status) {
			case GroupStatus.Armed:
				return "";
			case GroupStatus.Partial:
				return "text-warning";
			case GroupStatus.Disarmed:
				return "text-danger";
			default:
				return "";
		}

	}

	private groupOnTest(group: Group) {
		return this.showOnTestIcon && group.status === GroupStatus.OnTest;
	}

	private statusUpdate(group: Group): string {
		if (!this.showStatus || !group || !group.status || !group.lastArmedDisarmedAt) {
			return "";
		}
		switch (group.status) {
			case GroupStatus.Armed:
				return moment(group.lastArmedDisarmedAt).format("[Armed at] DD MMM YYYY HH:mm")
			case GroupStatus.Disarmed:
				return moment(group.lastArmedDisarmedAt).format("[Disarmed at] DD MMM YYYY HH:mm")
			default:
				return "";
		}
	}

	clicks: number = 0;
	clickTimer: any;

	@Eventqueue.Mutation toggleSiteTreeNodeOpen: any;

	public openNode() {
		this.toggleSiteTreeNodeOpen(this.node);
		this.nodeOpened(this.node);
	}

	public selectNode() {
		if(!this.isGroupSelectable) return;

		if (this.allowDoubleclick) {
			this.clicks++;

			if (this.clicks === 1) {
				this.clickTimer = setTimeout(() => {
					this.nodeSelected({
						group: this.group,
						tree: this,
						node: this.node
					});
					this.clicks = 0;
				}, 0.5 * this.$config.ANIMATION_DURATION);
			} else {
				if (this.clickTimer != null) clearTimeout(this.clickTimer);

				this.clicks = 0;
				this.nodeDoubleClick({
					group: this.group,
					tree: this,
					node: this.node
				});
			}
		} else {
			this.nodeSelected({
				group: this.group,
				tree: this,
				node: this.node
			});
		}
	}

	@Emit("onSelected")
	public nodeSelected(args: any) {
		return args;
	}

	@Emit("onDoubleClick")
	public nodeDoubleClick(args: any) {
		return args;
	}

	@Emit("onOpenNode")
	public nodeOpened(args: any) {
		return args;
	}

	private mouseDown() {

	}
}
